/**
 * Meganav hover
 * @returns {Void}
 */
function meganavHover() {
  const selectors = {
    trigger: '[data-hover-media-trigger]',
    triggerMobile: '[data-hover-media-trigger-mobile]',
    media: '[data-hover-media-handle]'
  }
  const attributes = {
    trigger: 'data-hover-media-trigger',
    triggerMobile: 'data-hover-media-trigger-mobile',
    media: 'data-hover-media-handle'
  }
  const triggers = [...document.querySelectorAll(selectors.trigger)];
  const mobileTriggers = [...document.querySelectorAll(selectors.triggerMobile)];
  const mediaBlocks = [...document.querySelectorAll(selectors.media)];

  if (!triggers.length || !mediaBlocks.length) {
    return;
  }

  /**
   * Show media .
   * @param {DOMElement} trigger 
   * @returns {Void}
   */
  const showMedia = (trigger) => {
    const block = mediaBlocks.find(block => block.getAttribute(attributes.media) === trigger.getAttribute(attributes.trigger) || block.getAttribute(attributes.media) === trigger.getAttribute(attributes.triggerMobile));

    if (!block) {
      return;
    }
    
    block.classList.add('active');
  }

  /**
   * Hide media.
   * @param {DOMElement} trigger 
   * @returns {Void}
   */
  const hideMedia = (trigger) => {
    const block = mediaBlocks.find(block => block.getAttribute(attributes.media) === trigger.getAttribute(attributes.trigger) || block.getAttribute(attributes.media) === trigger.getAttribute(attributes.triggerMobile));

    if (!block) {
      return;
    }
    
    block.classList.remove('active');
  }

  const handleMobileTrigger = (trigger) => {
    console.log('clicked', trigger);
    
    if (trigger.hasAttribute('open')) {
      showMedia(trigger);
      return;
    }

    hideMedia(trigger);
  }

  // Attach events
  triggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', () => showMedia(trigger))
    trigger.addEventListener('mouseleave', () => hideMedia(trigger))
    trigger.addEventListener('focusin', () => showMedia(trigger))
    trigger.addEventListener('focusout', () => hideMedia(trigger))
  })
  
  mobileTriggers.forEach(trigger => {
    trigger.addEventListener('toggle', () => handleMobileTrigger(trigger))
  })
}

meganavHover();
